// extracted by mini-css-extract-plugin
module.exports = {"picture":"ReviewAnswerDialog_picture__2JLdy"};